import React, { Component } from 'react';
import { Button, Icon, Input, InputNumber, Select, DatePicker, Dropdown, Menu } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new.js';
import { ExportFixedLine } from './PreviewModal';
import API_URL from '../../../../common/url';

const dateFormat = 'YYYY-MM-DD';
const InputGroup = Input.Group;
const { Option } = Select;
const { RangePicker } = DatePicker;

const defaultList = [
    { label: '是', value: 1 },
    { label: '否', value: 0 },
];
const symbolList = [
    { label: '=', value: 'Equals' },
    { label: '>', value: 'GreatThan' },
    { label: '>=', value: 'NotLess' },
    { label: '<', value: 'LessThan' },
    { label: '<=', value: 'NotGreat' },
];
const remittanceStatusList = [
    { label: '新建', value: 'NEW_CASH_REQ' },
    { label: '已通知请款', value: 'NOTICE_CASH_REQ' },
    { label: '已发起请款', value: 'CASH_REQ' },
    { label: '已确认请款', value: 'CONFIRM_REQ' },
    
];
const remittanceEditStatusList = [
    { label: '已申请调整请款', value: 'APPLIED_ADJUSTMENT' },
    { label: '拒绝调整请款', value: 'REJECT_REMITTANCE_ADJUSTMENT_APPLY' },
    { label: '同意调整请款', value: 'AGREE_REMITTANCE_ADJUSTMENT_APPLY' },
    { label: '申请调整客户付款单位', value: 'REMITTANCE_CUSTOMER_APPLY' },
    { label: '拒绝客户付款单位调整', value: 'REJECT_REMITTANCE_CUSTOMER_APPLY' },
    { label: '同意客户付款单位调整', value: 'AGREE_REMITTANCE_CUSTOMER_APPLY' },
]
const overAgingList = [
    { label: '0~30天', value: '0~30' },
    { label: '31~60天', value: '31~60' },
    { label: '61~150天', value: '61~150' },
    { label: '151~365天', value: '151~365' },
    { label: '365天以上', value: '365~10000' },
];

class Filter extends Component {
    state = {
        expand: false,
    }

    search = () => {
        this.props.search();
    }

    export = () => {
        this.props.export();
    }

    update = (...rest) => {
        const { invState } = sessionStorage;
        if (invState == 1) {
            this.props.canEditByInvStatus(() => this.props.update(...rest));
        } else {
            this.props.update(...rest);
        }
    }

    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'customerCompany':
            case 'bd':
            case 'pm':
            case 'ba':
            case 'csaUser':
            case 'invoiceBa': {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                onChange(searchParams);
                break;
            }
            case 'baUser': {
                const { value: id, text: name } = option;
                searchParams.baUserId = id;
                searchParams.baUserName = name;
                onChange(searchParams);
                break;
            }
            case 'cashReqNodeDate':
            case 'createTime':
            case 'invoiceDate':
            case 'dateInvoiceClosed': {
                const [start, end] = value;
                searchParams[`${key}Start`] = start;
                searchParams[`${key}End`] = end;
                onChange(searchParams);
                break;
            }
            case 'lineOfBusiness':
                searchParams.secondLineName = undefined;
            case 'investigationAreaId' : {
                searchParams[key] = value;
                value ? this.props.loadDiseaseList(value) : searchParams['diseaseId'] = value;
            }
            default:
                searchParams[key] = value;
                onChange(searchParams);
                break;
        }
    }

    showFixedLine = () => {
        this.ExportFixedLineRef.show();
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    handleClick = e => {
        if (e.key === 'requestCustom') {
            this.props.configColumn();
        } else if (e.key === 'contractFold') {
            this.props.foldSet();
        } else {
            this.props.sort(e.key);
        }
    }

    getFieldDisplaySet = () => {
        const { headerType } = this.props;
        let menu;
        if (headerType === 'SINGLE') {
            menu = (
                <Menu onClick={this.handleClick}>
                    <Menu.Item key="requestCustom">
                        <a>请款自定义显示</a>
                    </Menu.Item>
                    <Menu.Item key="requestSort">
                        <a>请款字段排序</a>
                    </Menu.Item>
                </Menu>
            );
        } else {
            menu = (
                <Menu onClick={this.handleClick}>
                    <Menu.Item key="contractFold">
                        <a>合同折叠设置</a>
                    </Menu.Item>
                    <Menu.Item key="contractSort">
                        <a>合同字段排序</a>
                    </Menu.Item>
                    <Menu.Item key="requestCustom">
                        <a>请款自定义显示</a>
                    </Menu.Item>
                    <Menu.Item key="requestSort">
                        <a>请款字段排序</a>
                    </Menu.Item>
                </Menu>
            );
        }
        return (
            <Dropdown key="dropdown" overlay={menu}>
                <Button type="primary">
                    字段显示设置
                </Button>
            </Dropdown>
        )
    }

    render () {
        const { isAdd, searchParams, listCollection, contractTypeList, dateModifyReason, businessList, areaOptions, diseaseOptions } = this.props;
        const {
            expenseType = [],
            invoiceType = [],
            paymentProgress = [],
        } = listCollection;
        const { expand } = this.state;
        const { lineOfBusiness, paymentProgressIds = [] } = searchParams;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });
        const areaOption = areaOptions.map(d => <Option key={String(d.value)} title={d.label}>{d.label}</Option>);
        const diseaseOption = diseaseOptions.map(d => <Option key={String(d.value)} title={d.label}>{d.label}</Option>);
        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const symbolOption = symbolList.map(i => <Option key={i.value}>{i.label}</Option>);
        const remittanceStatusOption = remittanceStatusList.map(i => <Option key={i.value}>{i.label}</Option>);
        const remittanceEditStatusOption = remittanceEditStatusList.map(i => <Option key={i.value}>{i.label}</Option>);
        const overAgingOption = overAgingList.map(i => <Option key={i.value}>{i.label}</Option>);
        const defaultOption = defaultList.map(i => <Option key={i.value}>{i.label}</Option>);
        const expenseTypeOptions = expenseType.map(i => <Option key={String(i.contractRemittanceDictId)}>{i.dictName}</Option>);
        const invoiceTypeOptions = invoiceType.map(i => <Option key={String(i.contractRemittanceDictId)}>{i.dictName}</Option>);
        const paymentProgressOptions = paymentProgress.map(i => <Option key={String(i.contractRemittanceDictId)}>{i.dictName}</Option>);
        const contractTypeOptions = contractTypeList.map(i => <Option key={String(i.typeConfigureId)}>{i.typeValue}</Option>);
        const dateModifyReasonOption = dateModifyReason.map(i => <Option key={i.typeConfigureId} title={i.typeValue}>{i.typeValue}</Option>);

        const { curRole, invState } = sessionStorage;
        const isPM = curRole === 'PM';
        const isBA = curRole === 'BA';
        const isBAL = curRole === 'BAL';
        const isBDM = curRole === 'BDM';
        const isPML = curRole === 'PML';
        const isCTA = curRole === 'CTA';
        const isVP = curRole === 'VP';
        const isBO = curRole === 'BO';
        const isBDO = curRole === 'BDO';
        const isFIN = curRole === 'FIN';
        const isCSA = curRole === 'CSA';
        const isCSAL = curRole === 'CSAL';
        const isTotal = invState == 1;
        return (
            <div style={{ marginBottom: 16 }}>
                <div className={`search-bar expand ${expand ? 'expanded' : ''}`} style={{maxHeight: !expand && 150}}>
                    <div className="expand-box">
                        <a onClick={this.toggleHeight}>
                            {expand ? "收起" : "展开"}
                            <Icon className="expand-icon" type={expand ? "up" : "down"} />
                        </a>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">请款单号</div>
                        <Input
                            placeholder="请输入"
                            style={{ width: 120 }}
                            value={searchParams.remittanceCode}
                            onKeyPress={this.handleKeyPress}
                            onChange={e => this.handleChange(e.target.value, 'remittanceCode')}
                        />
                    </div>
                    {
                        !isTotal &&
                        <div className="search-item">
                            <div className="ui-label">项目简称</div>
                            <Input
                                placeholder="请输入"
                                style={{ width: 140 }}
                                value={searchParams.investigationName}
                                onKeyPress={this.handleKeyPress}
                                onChange={e => this.handleChange(e.target.value, 'investigationName')}
                            />
                        </div>
                    }
                    {
                        !isTotal &&
                        <div className="search-item">
                            <div className="ui-label">JDE主项目号</div>
                            <Input
                                placeholder="请输入"
                                style={{ width: 120 }}
                                onKeyPress={this.handleKeyPress}
                                onChange={e => this.handleChange(e.target.value, 'investigationJdeMainCode')}
                            />
                        </div>
                    }
                    <div className="search-item">
                        <div className="ui-label">JDE项目号</div>
                        <Input
                            placeholder="请输入"
                            style={{ width: 120 }}
                            value={searchParams.investigationJdeCode}
                            onKeyPress={this.handleKeyPress}
                            onChange={e => this.handleChange(e.target.value, 'investigationJdeCode')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">项目领域</label>
                        <Select
                            allowClear={true}
                            style={{ width: 120 }}
                            placeholder="请选择"
                            value={searchParams.investigationAreaId}
                            onChange={value => this.handleChange(value, 'investigationAreaId')}
                        >
                            {areaOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">疾病</label>
                        <Select
                            allowClear={true}
                            style={{ width: 120 }}
                            placeholder="请选择"
                            disabled={!searchParams.investigationAreaId}
                            value={searchParams.diseaseId}
                            onChange={value => this.handleChange(value, 'diseaseId')}
                        >
                            {diseaseOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">客户付款单位</div>
                        <SearchRetrieve
                            keyword='customerCompanyName'
                            style={{ width: 160 }}
                            placeholder="输入客户名称或代码检索"
                            value={searchParams.customerCompanyName}
                            params={{ limit: 20 }}
                            url={API_URL.investigation.queryCustomerCompanyByName}
                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                            onChange={(option) => this.handleChange(option, 'customerCompany')}
                        />
                    </div>
                    {
                        !isTotal &&
                        <div className="search-item">
                            <div className="ui-label">项目编号</div>
                            <Input
                                placeholder="请输入"
                                style={{ width: 120 }}
                                onKeyPress={this.handleKeyPress}
                                onChange={e => this.handleChange(e.target.value, 'investigationCode')}
                            />
                        </div>
                    }
                    <div className="search-item">
                        <label className="ui-label">客户CSA</label>
                        <SearchRetrieve
                            keyword='keyWord'
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            value={searchParams.csaUserName}
                            params={{ limit: 20, roleCodes: 'CSA,CSAL' }}
                            url={API_URL.execute.queryEmpListByRoleCode}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => this.handleChange(option, 'csaUser')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">计收入确认方式</label>
                        <Select
                            style={{width: 100}}
                            placeholder="请选择"
                            onChange = {value => this.handleChange(value, 'contractTypeId')}
                            allowClear = {true}
                        >
                            {contractTypeOptions}
                        </Select>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">请款申请系统时间</div>
                        <RangePicker
                            placeholder={["开始日期", "结束日期"]}
                            style={{width: 200}}
                            format={dateFormat}
                            onChange={(dates, dateStrings) => this.handleChange(dateStrings, 'createTime')}
                        />
                    </div>
                    {
                        !isTotal &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">业务线</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{width: 120}}
                                value={lineOfBusiness}
                                onChange={value => this.handleChange(value, 'lineOfBusiness')}
                            >
                                {businessOption}
                            </Select>
                        </div>
                    }
                    <div className="search-item">
                        <div className="ui-label">请款记录状态</div>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width: 160 }}
                            onChange={value => this.handleChange(value, 'remittanceStatus')}
                        >
                            { remittanceStatusOption }
                        </Select>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">请款调整状态</div>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width: 160 }}
                            onChange={value => this.handleChange(value, 'remittanceChangeStatus')}
                        >
                            { remittanceEditStatusOption }
                        </Select>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">请款进度</div>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            value={paymentProgressIds}
                            mode='multiple'
                            style={{ width: 180 }}
                            onChange={value => this.handleChange(value, 'paymentProgressIds')}
                        >
                            {paymentProgressOptions}
                        </Select>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">确认可请款日期</div>
                        <RangePicker
                            placeholder={["开始日期", "结束日期"]}
                            style={{width: 200}}
                            format={dateFormat}
                            onChange={(dates, dateStrings) => this.handleChange(dateStrings, 'cashReqNodeDate')}
                        />
                    </div>
                    <div className="search-item">
                        <div className="ui-label">是否大于30天还未开票</div>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width: 80 }}
                            onChange={value => this.handleChange(value, 'isBigThanThirty')}
                        >
                            {defaultOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">超账龄</div>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width: 100 }}
                            onChange={value => this.handleChange(value, 'overAging')}
                        >
                            {overAgingOption}
                        </Select>
                    </div>
                    {
                        !isTotal &&
                        <div className="search-item">
                            <div className="ui-label">PM</div>
                            <SearchRetrieve
                                keyword='keyword'
                                style={{ width: 140 }}
                                placeholder="输入姓名/工号检索"
                                value={searchParams.pmName}
                                params={{ limit: 20 }}
                                url={API_URL.sumtotal.queryAllInvestigationPm}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                onChange={(option) => this.handleChange(option, 'pm')}
                            />
                        </div>
                    }
                    {
                        !isTotal &&
                        <div className="search-item">
                            <div className="ui-label">BD</div>
                            <SearchRetrieve
                                keyword='keyword'
                                style={{ width: 140 }}
                                placeholder="输入姓名/工号检索"
                                value={searchParams.bdName}
                                params={{ limit: 20 }}
                                url={API_URL.sumtotal.queryAllInvestigationBd}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                onChange={(option) => this.handleChange(option, 'bd')}
                            />
                        </div>
                    }
                    {
                        !isTotal &&
                        <div className="search-item">
                            <div className="ui-label">合同总金额/人民币(元)</div>
                            <InputGroup compact>
                                <Select
                                    value={searchParams.jdeContractAmountSymbol}
                                    onChange={value => this.handleChange(value, 'jdeContractAmountSymbol')}
                                >
                                    {symbolOption}
                                </Select>
                                <InputNumber
                                    style={{ width: 110 }}
                                    placeholder="请输入"
                                    onKeyPress={this.handleKeyPress}
                                    onChange={value => this.handleChange(value, 'jdeContractAmount')}
                                />
                            </InputGroup>
                        </div>
                    }
                    <div className="search-item">
                        <div className="ui-label">合同开始时间</div>
                        <InputGroup compact>
                            <Select
                                value={searchParams.startTimeSymbol}
                                onChange={value => this.handleChange(value, 'startTimeSymbol')}
                            >
                                {symbolOption}
                            </Select>
                            <DatePicker
                                style={{width: 100}}
                                allowClear={true}
                                onChange={(date, dateString) => this.handleChange(dateString, 'startTime')}
                            />
                        </InputGroup>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">合同结束时间</div>
                        <InputGroup compact>
                            <Select
                                value={searchParams.endTimeSymbol}
                                onChange={value => this.handleChange(value, 'endTimeSymbol')}
                            >
                                {symbolOption}
                            </Select>
                            <DatePicker
                                style={{width: 100}}
                                allowClear={true}
                                onChange={(date, dateString) => this.handleChange(dateString, 'endTime')}
                            />
                        </InputGroup>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">请款笔数</div>
                        <div style={{ lineHeight: '28px' }}>
                            第
                            <InputNumber
                                min={0}
                                precision={0}
                                placeholder="请输入"
                                style={{ margin: '0 4px', width: 60, verticalAlign: 'bottom' }}
                                onChange={value => this.handleChange(value, 'remittanceNum')}
                            />
                            笔
                        </div>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">发票类型</div>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width: 100 }}
                            onChange={value => this.handleChange(value, 'invoiceTypeId')}
                        >
                            {invoiceTypeOptions}
                        </Select>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">费用类型</div>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width: 100 }}
                            onChange={value => this.handleChange(value, 'expenseTypeId')}
                        >
                            {expenseTypeOptions}
                        </Select>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">请款联系人信息</div>
                        <Input
                            placeholder="请输入"
                            onKeyPress={this.handleKeyPress}
                            onChange={e => this.handleChange(e.target.value, 'cashReqUser')}
                        />
                    </div>
                    <div className="search-item">
                        <div className="ui-label">发票邮寄信息</div>
                        <Input
                            placeholder="请输入"
                            onKeyPress={this.handleKeyPress}
                            onChange={e => this.handleChange(e.target.value, 'invoiceMailUser')}
                        />
                    </div>
                    <div className="search-item">
                        <div className="ui-label">发票日期</div>
                        <RangePicker
                            placeholder={["开始日期", "结束日期"]}
                            style={{width: 200}}
                            format={dateFormat}
                            onChange={(dates, dateStrings) => this.handleChange(dateStrings, 'invoiceDate')}
                        />
                    </div>
                    <div className="search-item">
                        <div className="ui-label">发票号</div>
                        <Input
                            placeholder="请输入"
                            onKeyPress={this.handleKeyPress}
                            onChange={e => this.handleChange(e.target.value, 'remark')}
                        />
                    </div>
                    <div className="search-item">
                        <div className="ui-label">收款日期</div>
                        <RangePicker
                            placeholder={["开始日期", "结束日期"]}
                            style={{width: 200}}
                            format={dateFormat}
                            onChange={(dates, dateStrings) => this.handleChange(dateStrings, 'dateInvoiceClosed')}
                        />
                    </div>
                    <div className="search-item">
                        <div className="ui-label">发票金额(含税总额)总金额</div>
                        <InputNumber
                            min={0}
                            placeholder="请输入"
                            style={{ width: 120 }}
                            onChange={value => this.handleChange(value, 'grossAmount')}
                        />
                    </div>
                    <div className="search-item">
                        <div className="ui-label">确认收款金额</div>
                        <InputNumber
                            min={0}
                            placeholder="请输入"
                            style={{ width: 120 }}
                            onChange={value => this.handleChange(value, 'receivingAmount')}
                        />
                    </div>
                    {
                        !isTotal &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">执行业务线二级分类</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{width: 120}}
                                disabled={!lineOfBusiness}
                                value={searchParams.secondLineName}
                                onChange={value => this.handleChange(value, 'secondLineName')}
                            >
                                {secondLineOption}
                            </Select>
                        </div>
                    }
                    <div className="search-item">
                        <div className="ui-label">确认是否可在milestone到达日期后一个月内请款</div>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width: 80 }}
                            onChange={value => this.handleChange(value, 'isBaCashReq')}
                        >
                            {defaultOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">请款日期修改理由</div>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width: 260 }}
                            onChange={value => this.handleChange(value, 'baConfirmCashReqDateReason')}
                        >
                            {dateModifyReasonOption}
                        </Select>
                    </div>
                    <ExportFixedLine ref={el => this.ExportFixedLineRef = el} />
                </div>
                <div className="search-bar flex-end">
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        { !isTotal && <Button type="primary" onClick={this.props.toggleHeader}>切换成{this.props.headerType === 'SINGLE' ? '双' : '单'}表头</Button> }
                        {this.getFieldDisplaySet()}
                        <Button type="primary" onClick={this.export}>导出</Button>
                        { (isTotal || (isCTA || isVP || isBO || isBAL || isBDO || isFIN || isCSAL || isBA || isBAL )) && <Button type="primary" onClick={this.showFixedLine} style={{background:'#fc0',border:'1px solid #f93'}}>导出固化数据</Button> }
                        { (isAdd || isCSA || isCSAL ) && <Button type="primary" onClick={() => this.update(null, 'add')}>添加请款</Button> }
                    </div>
                </div>
            </div>
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/components/Filter.js